module.exports = __webpack_public_path__ + "img/idcardUP.da6e32f0.png";